/**
 * The two currency marks, drawn as SVG so they stay crisp at any size and in
 * either theme.
 *
 * Gaju is the 木 character on a light disc, as the Groot explorer uses it.
 * USDC is its own blue disc with the broken ring and dollar sign. The Gaju
 * disc inverts on a dark theme so the character keeps its contrast; the USDC
 * blue is a brand colour and stays as it is.
 */

export function GajuMark({ size = 16 }: { size?: number }) {
  return (
    <svg
      className="mark mark-gaju"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
    >
      <circle cx="16" cy="16" r="16" fill="#fff" />
      <text
        x="16"
        y="16"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="19"
        fill="#212529"
        fontFamily="'Hiragino Sans', 'Noto Sans CJK JP', 'PingFang SC', 'Microsoft YaHei', sans-serif"
      >
        木
      </text>
    </svg>
  );
}

export function UsdcMark({ size = 16 }: { size?: number }) {
  return (
    <svg className="mark" width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <circle cx="16" cy="16" r="16" fill="#2775CA" />
      {/* The broken ring: open at the left and the right, as the brand draws it. */}
      <path
        d="M16 5.2a10.8 10.8 0 00-7.64 18.44"
        fill="none"
        stroke="#fff"
        strokeWidth="2.1"
        strokeLinecap="round"
      />
      <path
        d="M16 26.8a10.8 10.8 0 007.64-18.44"
        fill="none"
        stroke="#fff"
        strokeWidth="2.1"
        strokeLinecap="round"
      />
      {/* The dollar sign. */}
      <path d="M16 9.1v13.8" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" />
      <path
        d="M19 12.6c0-1.6-1.35-2.6-3-2.6s-3 .9-3 2.5c0 1.5 1.2 2.2 3 2.7 1.9.5 3.2 1.2 3.2 2.9 0 1.7-1.4 2.7-3.2 2.7s-3.2-1-3.2-2.7"
        fill="none"
        stroke="#fff"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** XGE: the xchange mark in a navy circle. */
export function XgeMark({ size = 16 }: { size?: number }) {
  return (
    <svg className="mark" width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <circle cx="16" cy="16" r="16" fill="#1e3055" />
      <path
        d="M7 20l6-6.5a2.4 2.4 0 0 1 3.5 0L19 16l2.5-2.5H26l-6.5 7a2.4 2.4 0 0 1-3.5 0L13.5 18 11 20.5z"
        fill="#fff"
      />
    </svg>
  );
}
